<template>
  <div class="lesson-item-component">
    <div class="course-lesson-item">
      <div class="lesson-content">
        <h4 class="lesson-title ym-two-line-ellipsis">
          第{{ lesson.seq }}课 | {{ lesson.title }}
        </h4>
        <medal v-if="medal"
               class="lesson-medal"
               :medal="medal.src"
               :title="medal.title"
               :desc="medal.desc"
               :status="medal.status"
               lazy
        />
      </div>
      <div class="lesson-bottom">
        <div class="lesson-time">
          <ym-tag plain
                  type="disabled"
          >
            {{ weekString }}
          </ym-tag>
          <span class="time">{{ lesson.showStartTime | formatTime('yyyy年MM月dd日 HH:ii') }}</span>
        </div>
        <ym-button v-if="btn.type !== 'disabled'"
                   size="extra-small"
                   :class="{ 'will-be-live-btn': btn.type === 'text' }"
                   :type="btn.type"
                   :plain="btn.plain"
                   @click="handleClickBtn"
        >
          {{ btn.text }}
        </ym-button>
        <ym-button v-else
                   class="disabled-btn"
                   size="extra-small"
                   disabled
                   @click.native="handleClickDisabledBtn"
        >
          {{ btn.text }}
        </ym-button>
      </div>
      <div v-if="member && (challenge || practice || lesson.hasSummary)"
           class="lesson-after"
      >
        <div v-if="challenge"
             class="lesson-after-item"
        >
          <div class="lesson-after-item-left">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/icon_challenge.png')"
            />
            <div class="title">挑战</div>
            <div v-if="work"
                 class="label"
                 :class="{ 'active': work.isComment }"
            >
              {{ work.status === 'draft' ? '已保存草稿' : work.isComment ? '已评价' : '待评价' }}
            </div>
          </div>
          <ym-wx-open-launch-app v-if="!work"
                                 :url="`youthmba://course/challenge?id=${challenge.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">去挑战</button>
              </script>
            </div>
            <div class="lesson-after-item-right">
              去挑战
            </div>
          </ym-wx-open-launch-app>
          <ym-wx-open-launch-app v-else-if="work && work.status === 'draft'"
                                 :url="`youthmba://work/detail?id=${work.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 80px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">继续编辑</button>
              </script>
            </div>
            <div class="lesson-after-item-right draft">
              继续编辑
            </div>
          </ym-wx-open-launch-app>
          <ym-wx-open-launch-app v-else-if="work && work.status === 'normal'"
                                 :url="`youthmba://work/detail?id=${work.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    color: #13b9bf;
                    background-color: transparent;
                    border: 1px solid #02cccc;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    outline: none;
                  }
                </style>
                <button class="btn">查看</button>
              </script>
            </div>
            <div class="lesson-after-item-right is-plain">
              查看
            </div>
          </ym-wx-open-launch-app>
        </div>
        <div v-if="practice"
             class="lesson-after-item"
        >
          <div class="lesson-after-item-left">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/icon_practice.png')"
            />
            <div class="title">课后练一练</div>
          </div>
          <ym-wx-open-launch-app v-if="practice.status === 'complete'"
                                 :url="`youthmba://course/practice?id=${lesson.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    color: #13b9bf;
                    background-color: transparent;
                    border: 1px solid #02cccc;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    outline: none;
                  }
                </style>
                <button class="btn">看解析</button>
              </script>
            </div>
            <div class="lesson-after-item-right is-plain">
              看解析
            </div>
          </ym-wx-open-launch-app>
          <ym-wx-open-launch-app v-else
                                 :url="`youthmba://course/practice?id=${lesson.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">去答题</button>
              </script>
            </div>
            <div class="lesson-after-item-right">
              去答题
            </div>
          </ym-wx-open-launch-app>
        </div>
        <div v-if="lesson.hasSummary"
             class="lesson-after-item"
        >
          <div class="lesson-after-item-left">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/icon_summary.png')"
            />
            <div class="title">课后小结</div>
          </div>
          <ym-wx-open-launch-app :url="`youthmba://course/summary?id=${lesson.id}&token=${auth}`">
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">去查看</button>
              </script>
            </div>
            <div class="lesson-after-item-right">
              去查看
            </div>
          </ym-wx-open-launch-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button, Tag } from '@ymba/ym-ui';
  import Medal from '@/components/Medal';
  import YmWxOpenLaunchApp from '@/components/YmWxOpenLaunchApp';
  import { formatTime, locationHref, getAuth } from '@/utils';
  import validator from '@/utils/validator';
  import { getCourseLessonPLayUrl } from '@/services/course';

  export default {
    name: 'CourseDetailLessonItem',
    components: {
      Medal,
      YmTag: Tag,
      'ym-button': Button,
      YmWxOpenLaunchApp,
    },
    props: {
      courseId: {
        type: Number,
        required: true,
      },
      member: {
        type: Boolean,
        required: true,
      },
      lesson: {
        type: Object,
        required: true,
      },
      medal: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
      sellStatus: {
        type: String,
        required: true,
      },
      work: {
        type: Object,
      },
      practice: {
        type: Object,
      },
      challenge: {
        type: Object,
      },
    },
    computed: {
      weekString() {
        return `周${formatTime(this.lesson.showStartTime, 'a')}`;
      },
      btn() {
        const { status } = this.lesson;
        switch (status) {
          case 'willBeLive': {
            return {
              type: 'text',
              text: '即将开课',
              plain: true,
            };
          }
          case 'living': {
            return {
              type: 'primary',
              text: '直播中',
              plain: false,
            };
          }
          case 'hasReplay': {
            return {
              type: 'primary',
              text: '课程回放',
              plain: true,
            };
          }
          default: {
            return {
              type: 'disabled',
              text: '回放生成中',
              plain: true,
            };
          }
        }
      },
      auth() {
        return getAuth();
      },
    },
    methods: {
      handleClickBtn() {
        const { status } = this.lesson;
        const lessonId = this.lesson.id;
        switch (status) {
          case 'living':
            return this.enterClassroom(lessonId);
          case 'willBeLive':
            return this.handleWillBeLive();
          case 'hasReplay':
            return this.handleReplay(lessonId);
          default:
            return this.handleLiveEnd();
        }
      },
      handleClickDisabledBtn() {
        this.$toast('正在生成回放，请稍候');
      },
      async enterClassroom(lessonId) {
        if (this.member) {
          const data = await getCourseLessonPLayUrl(this.courseId, lessonId);
          if (data.action === 'location') {
            locationHref(data.originUrl);
            return;
          }
          this.$router.push({
            name: 'ClassRoomDetail',
            query: { courseId: this.courseId, lessonId },
          });
          return;
        }
        this.$toast('您尚未加入课程');
      },
      handleWillBeLive() {
        if (this.member) return;
        if (this.sellStatus === 'unstart') {
          this.$toast('课程暂未开售');
          return;
        }
        if (this.sellStatus === 'canJoin') {
          this.$toast('加入课程即可查看');
          return;
        }
        this.$toast('课程已开始，请点击下方"下期开课提醒我"设置提醒');
      },
      handleReplay(lessonId) {
        this.enterClassroom(lessonId);
      },
      handleLiveEnd() {
        this.$toast('正在生成回放中');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .course-lesson-item {
    overflow: hidden;
    margin: @size-base;
    padding: @size-base @size-base 0;
    border-radius: @border-radius-medium;
    background: @color-white;
  }

  .lesson-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }

  .lesson-title {
    flex: 1;
    overflow: hidden;
    font-size: @font-size-medium;
    font-weight: @font-weight-bold;
    margin: 0;
    line-height: 1.4;
  }

  .lesson-medal {
    margin-left: @size-base;
  }

  .lesson-bottom {
    padding-top: @size-small;
    padding-bottom: @size-base;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /deep/ .ym-tag {
      color: @color-text-light;
      font-size: @font-size-small;
      border-color: @color-text-lighter;
      border-radius: @border-radius-normal;
    }
    /deep/ .ym-button {
      padding: 0 16px;
      border-radius: 6px;
      font-size: 26px;
    }
    /deep/ .disabled-btn {
      color: @color-text-lighter;
      background: #f5f6f7;
      opacity: 1;
    }
    /deep/ .will-be-live-btn {
      color: @color-text-lighter;
    }
    /deep/ .ym-button--primary {
      background-color: #02cccc;
      border-color: #02cccc;
    }
    /deep/ .ym-button--primary.is-plain {
      background-color: transparent;
      border-color: #24b1b2;
      color: #13b9bf;
    }
  }

  .lesson-after {
    display: flex;
    flex-direction: column;
    border-top: @border-base;
    padding-bottom: @size-base;
    &-item {
      margin-top: @size-base;
      border-radius: @border-radius-medium;
      background-color: #f3fbfc;
      height: 120px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: @size-small;
      padding-right: @size-base;
      &-left {
        display: flex;
        align-items: center;
        .icon {
          width: @size-large;
          height: @size-large;
          margin-right: 5px;
        }
        .title {
          color: @color-text-base;
          font-size: @font-size-medium;
          font-weight: @font-weight-bold;
        }
        .label {
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
          margin-left: @size-base;
          box-sizing: border-box;
          border-radius: @border-radius-large;
          background-color: transparent;
          font-size: @font-size-extra-small;
          color: @color-text-lighter;
          border: 1px solid @color-text-lighter;
          &.active {
            color: #13b9bf;
            border: 1px solid #02cccc;
          }
        }
      }
      &-right {
        width: 126px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: @border-radius-large;
        background-color: #02cccc;
        color: @color-white;
        font-size: 26px;
        box-sizing: border-box;
        cursor: pointer;
        &.is-plain,
        &.normal {
          color: #13b9bf;
          background-color: transparent;
          border: 1px solid #02cccc;
        }
        &.draft {
          width: 152px;
        }
      }
    }
  }

  .lesson-time {
    display: flex;
    align-items: center;
    color: @color-text-light;
  }

  .time {
    margin-left: @size-small;
  }

  .btn-type-text {
    padding: 0;
    color: @color-primary;
  }

  .will-be-live-popup {
    color: @color-text-light;
    text-align: center;
    padding: 0 @size-medium @size-medium;
    line-height: 2;
  }

  @empty-img-size: 160px;
  .empty-img {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: @size-medium auto @size-base;
    width: @empty-img-size;
    height: @empty-img-size;
    border-radius: @border-radius-round;
    background-color: @background-color-base;
  }

  .live-seq {
    font-weight: @font-weight-primary;
  }

  .live-time {
    color: @color-text-primary;
  }
</style>
